import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3198">
      <Navbar data-id="element-3199" />
      <main data-id="element-3200">
        <ConsularAffairs data-id="element-3201" />
      </main>
      <Footer data-id="element-3202" />
      <FeedbackPopup data-id="element-3203" />
    </div>;
}